import { Button, MenuItem, Select, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';
const PurchaseServices = () => {
    const navigate = useNavigate();
    const serviceCardsData = [
        {
            title: "Content Writers UAE",
            subtitle: "Content Writing",
            rating: "4.9",
            reviews: 156,
            description: "Native English and Arabic copywriters crafting compelling product descriptions, engaging blog posts, social media content, and SEO-friendly articles tailored to your audience.",
            buttonText: "View Services",
        },
        {
            title: "SEO Experts Global",
            subtitle: "SEO Optimization",
            rating: "4.7",
            reviews: 102,
            description: "Boost your website’s search engine rankings with expert keyword research, on-page and off-page SEO, competitor analysis, and ongoing optimization strategies.",
            buttonText: "View Services",
        },
        {
            title: "Social Media Managers",
            subtitle: "Social Media",
            rating: "4.8",
            reviews: 198,
            description: "Engage your audience and grow your brand with creative content planning, community management, targeted advertising campaigns, and performance analytics.",
            buttonText: "View Services",
        },
        {
            title: "Graphic Designers",
            subtitle: "Design Services",
            rating: "4.9",
            reviews: 210,
            description: "Professional designers delivering custom logos, branding packages, marketing materials, social media graphics, and website visuals that captivate and convert.",
            buttonText: "View Services",
        },
        {
            title: "Web Developers",
            subtitle: "Development",
            rating: "4.6",
            reviews: 87,
            description: "Custom website development using modern frameworks, responsive design, e-commerce solutions, CMS integration, and ongoing maintenance to ensure optimal performance.",
            buttonText: "View Services",
        },
        {
            title: "Translation Services",
            subtitle: "Language Solutions",
            rating: "4.8",
            reviews: 134,
            description: "Accurate, culturally sensitive translations by native speakers across over 20 languages, including documents, websites, marketing content, and technical manuals.",
            buttonText: "View Services",
        },
    ];

    return (
        <>
            <div className="main_title">
                <h1>Services</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Services
                </p>
            </div>

            <div className="cards">
                <div className="table_header">

                    <div className="left_s " >
                        <div className="form">

                            <TextField placeholder="Search by service" hiddenLabel fullWidth />
                            <Select defaultValue="All">
                                <MenuItem value="All">Category</MenuItem>
                                <MenuItem value="Sale">Photography</MenuItem>
                                <MenuItem value="Commission">Graphic Design</MenuItem>
                                <MenuItem value="Ad">Content Writing</MenuItem>
                                <MenuItem value="Refund">Social Media</MenuItem>
                            </Select>
                        </div>
                    </div>


                </div>
                <div className="services">
                    {serviceCardsData.map(({ title, subtitle, rating, reviews, description, buttonText }, idx) => (
                        <div key={idx} className="service-card" onClick={() => navigate("view")}>
                            <div className="card_top">
                                <figure>
                                    <img src="/static/images/placeholder.png" alt="icon" />
                                </figure>
                                <h3>
                                    {title}
                                    <span>{subtitle}</span>
                                </h3>
                            </div>
                            <h4>
                                <StarIcon style={{ color: '#ffb400', verticalAlign: 'middle' }} />
                                {rating}({reviews})
                            </h4>
                            <p>{description}</p>
                            <Button className="btn btn_primary sm">{buttonText}</Button>
                          
                        </div>
                    ))}

                </div>
            </div>




        </>
    );
};

export default PurchaseServices;
